import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';
import { ApplicantModel } from '../../../shared/models/states/applicant.model';

@Injectable({
    providedIn: 'root',
})
export class JointApplicantService extends AbstractApiGuardService {
    private readonly apiUrl = `${environment.apiVersionString}/joint_applicants`;

    // Create an application
    createJointApplicant(application: ApplicantModel, loanId: string): Observable<ApplicantModel> {
        return this.post<ApplicantModel>(`${this.apiUrl}/${loanId}`, application).pipe(map(setApplicantType));
    }

    // Read all applications
    // getLoanApplicants(): Observable<ApplicantModel[]> {
    //   return this.get(this.apiUrl);
    // }

    getJointApplicantsByLoanId(loan_application_uuid: string): Observable<ApplicantModel[]> {
        return this.get<ApplicantModel[]>(`${this.apiUrl}/loan_application_id/${loan_application_uuid}`).pipe(map(setApplicantTypes));
    }

    // Read a single application by ID
    getJointApplicantById(id: string): Observable<ApplicantModel> {
        return this.get<ApplicantModel>(`${this.apiUrl}/applicant_id/${id}`).pipe(map(setApplicantType));
    }

    // Update an application
    updateJointApplicant(id: string, application: ApplicantModel): Observable<ApplicantModel> {
        return this.put<ApplicantModel>(`${this.apiUrl}/${id}`, application).pipe(map(setApplicantType));
    }

    // Delete an application
    deleteJointApplicant(id: string): Observable<void> {
        return this.delete(`${this.apiUrl}/${id}`);
    }
}

function setApplicantType(a: ApplicantModel): ApplicantModel {
    return {
        ...a,
        applicant_type: "Joint"
    }
}

function setApplicantTypes(a: ApplicantModel[]): ApplicantModel[] {
    return a.map(setApplicantType);
}
